module.exports = {
	"id": "GD",
	"name": "Grenada",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.018831,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.18831,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006277,
			"29": 0.006277,
			"30": null,
			"31": 0.232249,
			"32": null,
			"33": null,
			"34": 0.012554,
			"35": 0.031385,
			"36": 0.012554,
			"37": 0.006277,
			"38": 0.018831,
			"39": 0.018831,
			"40": 0.081601,
			"41": 0.012554,
			"42": null,
			"43": 0.043939,
			"44": 0.025108,
			"45": 0.37662,
			"46": 0.025108,
			"47": 0.056493,
			"48": 0.012554,
			"49": 1.657128,
			"50": 0.131817,
			"51": 0.464498,
			"52": 0.320127,
			"53": 26.212752,
			"54": 6.459033,
			"55": 0.156925,
			"56": 0.075324,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.012554,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.037662,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.025108,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.018831,
			"39": 0.081601,
			"40": 0.012554,
			"41": null,
			"42": 0.037662,
			"43": 0.031385,
			"44": 0.025108,
			"45": 0.031385,
			"46": 0.012554,
			"47": 0.370343,
			"48": 0.370343,
			"49": 4.073773,
			"50": 0.106709,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.031385,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.012554,
			"34": null,
			"35": 0.018831,
			"36": 0.056493,
			"37": 0.244803,
			"38": 0.031385,
			"39": null,
			"40": 0.665362,
			"41": 0.100432,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.025108
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006277,
			"6": null,
			"7": 0.012554,
			"8": 1.311893,
			"9": 0.119263,
			"10": 1.079644,
			"3.1": null,
			"3.2": null,
			"5.1": 0.037662,
			"6.1": 0.025108,
			"7.1": 0.006277,
			"9.1": 0.853672
		},
		"ios_saf": {
			"8": 0,
			"10": 3.16856439217,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0853891439425,
			"8.1-8.4": 0.15775282525,
			"9.0-9.2": 0.0752582285595,
			"9.3": 1.14817041007
		},
		"android": {
			"3": 0,
			"4": 0.0956916821705,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0119614602713,
			"4.1": 0.345173567829,
			"4.2-4.3": 0.862933919574,
			"4.4": 1.97876728488,
			"4.4.3-4.4.4": 1.99585508527
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.106709,
			"9": 0.37662,
			"10": 0.238526,
			"11": 5.812502,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0305530034565,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000848694540457
		},
		"edge": {
			"12": 0.175756,
			"13": 0.954104,
			"14": 2.25972
		},
		"ie_mob": {
			"10": 0.271621690141,
			"11": 1.10588830986
		},
		"bb": {
			"7": 0.1098285,
			"10": null
		},
		"samsung": {
			"0": 3.008184
		},
		"and_uc": {
			"0": 0.368577
		},
		"op_mini": {
			"0": 0.411635302003
		},
		"and_chr": {
			"0": 27.109625
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 98.8164485
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GD.json
 ** module id = 526
 ** module chunks = 0
 **/